import React, { useState, useEffect } from 'react';
import Button from '../../ui/Button';
import { getFirestore, collection, doc, onSnapshot, addDoc, setDoc, deleteDoc } from 'firebase/firestore';
import styles from './RssFeedsAdmin.module.css';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { HiPlus, HiTrash, HiPencil } from 'react-icons/hi2';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function RssFeedsAdmin() {
  //const db = getFirestore();
  const colRef = collection(firestore, 'rssFeeds');

  const [feeds, setFeeds] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ title: '', url: '', enabled: true, scheduleMinutes: 60, limit: 10 });
  const { notify } = useNotifications();
  const { user, userData, claims } = useAuth(); 
  const { t } = useTranslation(); 
  
  useEffect(() => {
    return onSnapshot(colRef, snap => {
      setFeeds(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, []);

  const saveFeed = async e => {
    e.preventDefault();
    if (editingId) {
      await setDoc(doc(firestore, 'rssFeeds', editingId), { ...form, id: editingId });
      setEditingId(null);
    } else {
      const ref = await addDoc(colRef, form);
      await setDoc(doc(firestore, 'rssFeeds', ref.id), { ...form, id: ref.id });
    }
    setForm({ title: '', url: '', enabled: true, scheduleMinutes: 60, limit: 10 });
  };

  const startEdit = f => {
    setEditingId(f.id);
    setForm({ title: f.title, url: f.url, enabled: f.enabled, scheduleMinutes: f.scheduleMinutes, limit: f.limit });
  };

  const deleteFeed = async id => {
    if (window.confirm('Delete this feed?')) {
      await deleteDoc(doc(firestore, 'rssFeeds', id));
    }
  };

  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }


  return (
 	<>
    <LightNav/>
    <div className={styles.container}>
      <h2>{t('admin.rssFeedsTitle')}</h2>

      <form onSubmit={saveFeed} className={styles.form}>
        <input
          type="text"
          placeholder="Title"
          value={form.title}
          required
          onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
        />
        <input
          type="url"
          placeholder="Feed URL"
          value={form.url}
          required
          onChange={e => setForm(f => ({ ...f, url: e.target.value }))}
        />

        <label>
          <input
            type="checkbox"
            checked={form.enabled}
            onChange={e => setForm(f => ({ ...f, enabled: e.target.checked }))}
          />
          Enabled
        </label>

        <input
          type="number"
          min="1"
          value={form.scheduleMinutes}
          required
          onChange={e => setForm(f => ({ ...f, scheduleMinutes: +e.target.value }))}
        />
        <span>{t('admin.minutes')}</span>

        <input
          type="number"
          min="10"
          value={form.limit}
          required
          onChange={e => setForm(f => ({ ...f, limit: +e.target.value }))}
        />
		<span>{t('admin.limit')}</span>
        <Button type="submit" variant="primary">{editingId ? t('admin.updateFeed') : t('admin.addFeed')}</Button>
        {editingId && (
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              setEditingId(null);
              setForm({ title: '', url: '', enabled: true, scheduleMinutes: 60, limit: 10 });
            }}
          >
            Cancel
          </Button>
        )}
      </form>

      <div className={styles.list}>
        {feeds.length ? feeds.map(f => (
          <div key={f.id} className={styles.feed}>
            <div>
              <strong>{f.title}</strong> - {f.scheduleMinutes}min - {f.enabled ? 'enabled' : 'disabled'}
            </div>
            <div className={styles.actions}>
              <Button variant="ghost" onClick={() => startEdit(f)}><HiPencil /></Button>
              <Button variant="ghost" onClick={() => deleteFeed(f.id)}><HiTrash /></Button>
            </div>
          </div>
        )) : <p>{t('admin.noRssFeeds')}</p>}
      </div>
    </div>
	</>
  );
}
